import type { EnergySensorsTotalizer } from '@/interfaces/stores/rate'
import { ref, computed } from 'vue'

export function useRateChart(sensorData: EnergySensorsTotalizer[] = []) {
  const seriesPeakDemand = computed(() => {
    return sensorData.map((sensor) => ({
      name: sensor.sensor_name,
      value: sensor.totalizer.consumption.off_peak_consumption_kwh || 0,
    }))
  })

  const series = ref([
    {
      name: 'Consumo fora ponta (kW)',
      data: seriesPeakDemand.value.map((sensor) => sensor.value),
    },
  ])

  const categories = ref(sensorData.map((sensor) => sensor.sensor_name) || [])

  const chartOptions = ref({
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    colors: ['#1F77B4'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toFixed(1)} kW`,
    },
    xaxis: {
      categories: categories.value,
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val: number) => `${val.toFixed(1)} kW`,
      },
    },
    legend: {
      show: true,
      position: 'bottom',
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val: number) => `${val.toFixed(1)} kW`,
      },
    },
  })

  return { chartOptions, series }
}
